import type { ShowProps } from '@chakra-ui/react';
import { Show } from '../show-hide/show-hide';

export function LineBreak({ showAbove = 'xl' }: { showAbove?: ShowProps['above'] }) {
    return <Show above={showAbove}><br /></Show>;
}
